import React from 'react';
import LabeledField from './labeled-field';
import { useSellerFormattedDate } from '../../../../hooks/use-datetime-formats';

import style from './order-summary.module.less';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import PropTypes from 'prop-types';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';

import messages from './messages';
import { FormattedMessage } from 'react-intl';
import { FlexColumn } from 'ui-components/components/flex';

const LabeledDateField = ({ label, dateValueUtc }) => {
  const formattedEntityDate = useSellerFormattedDate(dateValueUtc) ?? <>&mdash;</>;
  return (
    <LabeledField label={<FormattedMessage {...label} />}>
      <div className={style['field-content']}>{formattedEntityDate}</div>
    </LabeledField>
  );
};

LabeledDateField.propTypes = {
  label: MessageDescriptorPropType.isRequired,
  dateValueUtc: PropTypes.string,
};

const Dates = () => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};

  const { paidDateTime, orderDateTime, shipByDateTime } = salesOrder;

  return (
    <FlexColumn className={style['split-flex-row']}>
      <LabeledDateField dateValueUtc={paidDateTime} label={messages.paidDateLabel} />
      <LabeledDateField dateValueUtc={orderDateTime} label={messages.orderDateLabel} />
      <LabeledDateField dateValueUtc={shipByDateTime} label={messages.shipByDateLabel} />
    </FlexColumn>
  );
};

export default Dates;
